import * as React from 'react';
import { CalendarViewToggleProps } from '../../components/calendar-view-toggle';
import { CalendarViewMode } from '../../classes/calendar';


const CalendarModeToggleView: React.StatelessComponent<CalendarViewToggleProps> = props => {
    return (
        <div className="ace-cal-subnav-item ace-cal-toggles">
            <button className="un-button primary-link ace-cal-toggle" type="button" disabled={props.calendarMode === CalendarViewMode.LIST} onClick={() => props.setToList(props.currentDate, props.startMonth)}>{props.text.listViewModeButtonText}</button>
            <button className="un-button primary-link ace-cal-toggle" type="button" disabled={props.calendarMode === CalendarViewMode.GRID} onClick={() => props.setToGrid(props.currentDate, props.startMonth)}>{props.text.gridViewModeButtonText}</button>
        </div>
    );
}

export default CalendarModeToggleView;